<div class="row">
  <div class="col-12 text-center">
    <h2>Aggiornamento & Analisi Trading System</h2>
  </div>
</div>
<div class="row">
  <div class="col-12 text-right">
    <button (click)="aggiorna_pp_m12()" class="btn btn-primary">Aggiorna TS 12 mesi</button>
    <div *ngIf="updateOK" class="alert alert-success">Aggiornamento completato!</div>
    <div *ngIf="updateKO" class="alert alert-danger">Aggiornamento Fallito!</div>
    <div *ngIf="updateRunning" class="alert alert-info">Aggiornamento in corso.. {{updatingMarket}}</div>
  </div>
</div>
<!--Top Table UI-->
<div class="my-5 card">
  <div class="card-header">
    <div class="card-body">

      <div class="row">

        <div class="col-12">
          <app-lista-pulsanti-mercati [soloForex]="false" (mercatoSelezionato)="selMarket2($event)"></app-lista-pulsanti-mercati>
        </div>
      </div>

      <div class="row mt-5">

        <div class="col-xl-3 col-lg-6 col-md-6">
          <label class="active">Pattern</label>
          <mdb-select [formControl]="selPattern" placeholder="Seleziona il Pattern">
            <mdb-option [value]="0" selected>Tutti</mdb-option>
            <mdb-option [value]="1">Pattern A</mdb-option>
            <mdb-option [value]="-1">Pattern B</mdb-option>
          </mdb-select>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-6">
          <label class="active">Giorno Settimana</label>
          <mdb-select [formControl]="selGiorno" placeholder="Seleziona il giorno">
            <mdb-option value="0" selected>Tutti</mdb-option>
            <mdb-option *ngFor="let option of showOnlyOptionsSelect" [value]="option.value">{{ option.label }}
            </mdb-option>
          </mdb-select>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-6">
          <label class="active">Ora Inizio</label>
          <mdb-select [formControl]="selOrario" placeholder="Orario di riferimento">
            <mdb-option value="0">Tutte le ore</mdb-option>
            <mdb-option *ngFor="let opt of orari" [value]="opt">
              {{opt}}
            </mdb-option>
          </mdb-select>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6">
          <label class="active">Ultimo valore</label>
          <div>
            {{ultimovalore}}
          </div>
          <div>{{tipopattern}}</div>
        </div>

      </div>

      <!--Grid row-->
    </div>
  </div>
</div>
<!--Top Table UI-->
<div class="row m-5 justify-content-center" *ngIf="loader">

  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="row" *ngIf="ideaTrading">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Idea Trading</h4>
        <p class="card-text mt-3 mb-4">BUY at {{levelBuy | number : '1.4-4'}} TP {{tpBuy | number : '1.4-4'}} SL {{slBuy
          | number : '1.4-4'}} RR {{rrBuy | number: '1.4-4' }}</p>
        <p class="card-text mt-3 mb-4">SELL at {{levelSell | number : '1.4-4'}} TP {{tpSell | number : '1.4-4'}} SL
          {{slSell | number : '1.4-4'}} RR {{rrSell | number: '1.4-4' }}</p>
      </div>
    </div>
  </div>
</div>
<div class="card" cascade="true" narrower="true">
  <!--Card image-->
  <div class="py-2 mx-4 mb-3 d-flex justify-content-between bg-primary align-items-center" style="border-radius: 10px;">
    <span class="text-light mx-3">Analisi Trading Systems ({{tableData.length}} su {{listaCompleta.length}})</span>
    <span class="mx-3" style="font-size: 16pt; font-weight: bold; color: yellow">{{selMercato.value?.toUpperCase()}}</span>
  </div>

  <div class="px-4">

    <div class="table-wrapper">
      <table  hover="true">

        <thead>
          <tr style="font-size: smaller;">
            <th class="th-md2" rowspan="2" *ngIf="colMarket">
              Mercato                
            </th>
            <th class="th-md2" rowspan="2" *ngIf="colPattern">Pattern
            </th>
            <th class="th-md2" rowspan="2" *ngIf="colGiorno">Giorno
            </th>
            <th class="th-md2" rowspan="2">Ora P
            </th>
            <th class="th-md2" rowspan="2">
              <a (click)="sortBy('oraclosep')">Ora Close
                <i class="fas fa-sort"></i>
              </a>
            </th>
            <th class="th-md2" rowspan="2">Num Op
            </th>
            <th class="th-md2" rowspan="2">
              <a (click)="sortBy('puntiop')">Media punti UP
                <i class="fas fa-sort"></i>
              </a>
            </th>
            <th class="th-md2" rowspan="2">
              <a (click)="sortBy('rawal')">Rawal
                <i class="fas fa-sort"></i>
              </a>
            </th>
            <th class="th-md2" rowspan="2">
              <a (click)="sortBy('kelly')">Kelly
                <i class="fas fa-sort"></i>
              </a>
            </th>
            <th class="th-md2" rowspan="2">
              <a (click)="sortBy('percpos')">Perc UP
                <i class="fas fa-sort"></i>
              </a>
            </th>
            <th class="th-md2" rowspan="2">
              <a>Avg UP
                <!-- <i class="fas fa-sort"></i> -->
              </a>
            </th>
            <th class="th-md2" rowspan="2">
              <a>Avg DOWN
                <!-- <i class="fas fa-sort"></i> -->
              </a>
            </th>
            <th class="th-md2" colspan="2">
              <a> In Positive Day</a>
            </th>
            <th class="th-md2" colspan="2">
              <a> In Negative Day</a>
            </th>
            <th class="th-md2" rowspan="2">
              Azioni
            </th>
          </tr>
          <tr style="font-size: smaller;">
            <th class="th-md2">
              <a> Avg MaxDD</a>
            </th>
            <th class="th-md2">
              <a> Avg Max R-UP</a>
            </th>
            <th class="th-md2">
              <a> Avg MaxDD</a>
            </th>
            <th class="th-md2">
              <a> Avg R-UP</a>
            </th>
          </tr>
        </thead>
        <!--Table head-->

        <!--Table body-->
        <tbody>
          <tr *ngFor="let row of tableData;let i = index">
            <td *ngIf="colMarket">
              {{row.market}}
            </td>
            <td *ngIf="colPattern">{{row.pattern==1 ? 'A' : 'B'}}</td>
            <td *ngIf="colGiorno">{{row.dayweek}}</td>
            <td class="cell-right">{{row.orap}}</td>
            <td class="cell-right">{{row.oraclosep}}</td>
            <td class="cell-right">{{row.numop | number}}</td>
            <td class="cell-right">{{row.puntiop | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.rawal | number: '1.2-2' }}</td>
            <td class="cell-right">{{row.kelly | number: '1.2-2' }}</td>
            <td class="cell-right">{{row.percpos | percent:'1.2-2' }}</td>
            <td class="cell-right">{{row.avgwin | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.avgloss | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.avghighpos | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.avglowpos | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.avghighneg | number: '1.4-4' }}</td>
            <td class="cell-right">{{row.avglowneg | number: '1.4-4' }}</td>
            <td class="cell-right" style="padding-left: 30px;">
              <a class="me-4" (click)="apriGrafico(row.market, row.dayweek, row.pattern, row.orap, row.oraclosep)">
                <i class="fas fa-chart-line"></i>
              </a>
              <button class="btn btn-outline-primary btn-floating btn-sm" (click)="addPref(row.id)">
                <i *ngIf="!row.id_rep" class="fas fa-plus-circle"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <!--Table body-->
      </table>
      <!--Table-->
    </div>
  </div>
</div>